import * as tslib_1 from "tslib";
import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';
/**
 * A flying-club search result returned by the AirportsAPI `~/flying-clubs` endpoint. A flying club is a
 * business carrying the "Flying Club" tag (TagId 165). Mirrors the `AviationEvent` model's
 * `static parse` convention.
 */
var FlyingClubResult = /** @class */ (function (_super) {
    tslib_1.__extends(FlyingClubResult, _super);
    function FlyingClubResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlyingClubResult.parse = function (data) {
        return Object.assign(new FlyingClubResult(), {
            businessId: data.businessId,
            name: data.name || null,
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            latitude: isNumeric(data.latitude) ? +data.latitude : null,
            longitude: isNumeric(data.longitude) ? +data.longitude : null,
            location: (isNumeric(data.latitude) && isNumeric(data.longitude))
                ? parseLatLon(data.latitude, data.longitude) : null,
            phone1: data.phone1 || null,
            webAddress: data.webAddress || null,
            emailAddress: data.emailAddress || null,
            description: data.description || null,
            distance: isNumeric(data.distance) ? +data.distance : null,
            airportIdent: data.airportIdent || null,
            airportName: data.airportName || null,
            tags: (data.tags || []).map(function (d) { return d; }),
            clubType: data.clubType || null,
            newMembers: data.newMembers || false,
            clubMembers: isNumeric(data.clubMembers) ? +data.clubMembers : null,
            clubAircraft: isNumeric(data.clubAircraft) ? +data.clubAircraft : null,
            thumbnailPhotoPath: data.thumbnailPhotoPath || null
        });
    };
    return FlyingClubResult;
}(BusinessFinderResult));
export { FlyingClubResult };
